// extracted by mini-css-extract-plugin
export default {"container":"MapDesktop_container__10bjl","map_container":"MapDesktop_map_container__kS6aE","save":"MapDesktop_save__JYJsy","button_container":"MapDesktop_button_container__5IPxj"};